import { renderImage } from "../../../common/function/shopping";
import { OrderProductContainer } from "../styled";

const Products = ({ products = [] }) => {
  const getTotalPrice = (item) => {
    const base = item.productPrice || 0;
    const optionTotal = (item.options || []).reduce(
      (sum, opt) => sum + (opt.price ?? 0) * (opt.qty ?? 1),
      0,
    );
    return base + optionTotal;
  };

  return (
    <OrderProductContainer>
      <p className="title">
        주문상품 {products.reduce((sum, group) => sum + group.products.length, 0)}개
      </p>
      <div className="groups">
        {products.map((group) => (
          <div key={group.cmpnyNo}>
            <strong>{group.cmpnyNm}</strong>
            <ul>
              {group.products.map((item) => (
                <li>
                  {renderImage(item)}
                  <div className="product">
                    <p>{item.productName}</p>
                    {item.options && item.options.length > 0 && (
                      <p className="options">
                        <span>{item.options.map((opt) => opt.name).join(" · ")}</span>
                      </p>
                    )}
                    <p>
                      <span>{formatNumber(getTotalPrice(item))}원</span>
                      <span> · </span>
                      <span>{item.quantity}개</span>
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </OrderProductContainer>
  );
};

export default Products;
